<template lang="pug">
    el-upload.upload-demo(
        :action='url'
        ref='upload'
        :show-file-list='true'
        :with-credentials='true'
        :before-remove='beforeRemove'
        :before-upload='beforeUpload'
        multiple
        :limit='limite'
        :on-exceed='handleExceed'
        :on-success='handleSuccess'
        :on-remove='handleRemove'
        :file-list='fileList'
        :data='dadosExtra'
    )
        el-button.upload-button(icon='el-icon-upload') {{ texto }}
        template(#tip)
            .el-upload__tip PDF, JPG, PNG e JPGE. Tamanho máx: 20MB.
</template>

<script>

export default {
	name: 'BotaoUploadComponent',
	props: {
		texto: {
			type: String,
			default: 'Selecione o(s) arquivo(s)'
		},
		fileList: {
			type: Array,
			default: () => [],
		},
		limite: {
			type: Number,
			default: 1
		},
		dadosExtra: {
			type: Object,
			required: false,
			default: () => ({})
		},
	},
	data() {
		return {
            url: '',
        }
	},
    mounted() {
		this.url = process.env.VUE_APP_ANALISE_PRADA_URL + 'api/upload';
    },
	methods: {
		handleSuccess(res, file) {
			this.$emit('file-upload', file?.response);
		},
		handleRemove(file, fileList) {
			this.$emit('file-removed', file?.response || file);
		},
		handleExceed() {
			this.$notify({
				title: 'Atenção!',
				message: `É permitido anexar apenas ${this.limite} arquivos.`,
				showClose: true,
				type: 'warning'
			});
		},
		beforeRemove(file) {
			if (file?.raw?.invalido) return true;
			return this.$confirm(`Tem certeza de que deseja cancelar o upload do arquivo ${ file.name } ?`);
		},
		beforeUpload(file) {
			const tamanhoValido = (file.size / 1024 / 1024) < 20;
			const formatoValido = ['application/pdf', 'image/png', 'image/jpg', 'image/jpeg'].includes(file.type);
			if (!tamanhoValido || !formatoValido) {
				file.invalido = true;
				const erro = !tamanhoValido ? 'Tamanho' : 'Formato';
				this.$notify({
					title: 'Atenção!',
					message: `${erro} do arquivo é inválido.`,
					showClose: true,
					type: 'warning'
				});
				return false;
			}
		},
	}
}
</script>

<style lang="scss">
@import '@/styles/variaveis.scss';

.el-button--primary {
	background: $primary-color !important;
	border: $primary-color !important;
}

.el-button--small:hover {
  color: #4e4e4e;
  border-color: #41b739 !important;
  background-color: #fafafa;
}

.el-icon-close-tip {
  display: none !important;
}

.el-upload-list__item-name:hover {
	color: $primary-color !important;
}

.el-upload__tip {
	margin-top: 0px !important;
	line-height: 20px !important;
	font-size: 10px !important;
}

.upload-button {
    background: #ddd;
  &:focus {
    background: #afafaf !important;
    color: #333333 !important;
    border-color: #DCDFE6 !important;
  }

  &:hover {
    background: #afafaf !important;
    color: #333333 !important;
    border-color: #DCDFE6 !important;
    opacity: 0.8;
  }
}
</style>